import { ZfAccordion, ZfAccordionItem, ZfDivider, ZfLoadingSpinner, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useClient } from '../../../api';
import type { TopicDto } from '../../../api/generated/client';
import { useNeedContentContext } from '../../../contexts/need-content-context';
import { TopicListItem } from '../components/TopicListItem';
import { TopicListSidebar } from '../components/TopicListSidebar';

const PADDING = 40;
const ACCORDION_TITLE_HEIGHT = 61;

export interface IProps {
    topic: TopicDto;
    containerDimensionsHeight: number;
}

export const TopicListPanel: FunctionComponent<IProps> = ({ topic, containerDimensionsHeight }) => {
    const { t } = useTranslation();
    const [isEditMode, setIsEditMode] = useState(false);
    const [isShowingAllTopics, setIsShowingAllTopics] = useState(false);
    const { talkingPoints, isTalkingPointRefetch } = useNeedContentContext();
    const { data: client } = useClient();
    const talkingPointPins = client?.talkingPointPins ?? [];
    const allTopicsContainerMaxHeight = `${(containerDimensionsHeight - PADDING * 2) / 2 - ACCORDION_TITLE_HEIGHT}px`;

    const onEdit = () => {
        setIsShowingAllTopics(!isEditMode);
        setIsEditMode(!isEditMode);
    };

    if (!talkingPoints || isTalkingPointRefetch) {
        return <ZfLoadingSpinner />;
    }

    return (
        <div className="topic-screen__panel_1">
            <div
                style={isShowingAllTopics ? { maxHeight: '50%', height: '50%', overflowY: 'auto' } : { flexGrow: 1 }}
                className="topic-screen__panel_1__my-topics"
            >
                <div className="topic-screen__panel_1__header">
                    <h4>{t('titleKeyMyTopics')}</h4>
                    <ZfTextButton hierarchy="tertiary" size="small" className="m-auto-0" onClick={onEdit}>
                        {isEditMode ? t('done') : t('modalEditButton')}
                    </ZfTextButton>
                </div>
                <div className="topic-screen__sidebar__questions-container" style={{ overflowY: 'auto' }}>
                    {talkingPoints
                        ?.filter((talkingPoint: { id: number }) =>
                            talkingPointPins.some((pin) => pin.talkingPointId === talkingPoint.id && pin.topicId === topic.id),
                        )
                        .map((talkingPoint, index) => (
                            <TopicListItem
                                key={talkingPoint.id}
                                point={talkingPoint}
                                showLeadingCheckbox={isEditMode}
                                hasBorderBottom={index < talkingPointPins.length - 1}
                            />
                        ))}
                </div>
            </div>
            <ZfDivider />
            <div>
                <ZfAccordion>
                    <ZfAccordionItem
                        size="extra-large"
                        titleText={t('allTopics')}
                        showUnderline={false}
                        state={isShowingAllTopics ? 'active' : 'default'}
                        onAccordionToggle={() => setIsShowingAllTopics(!isShowingAllTopics)}
                    >
                        <TopicListSidebar showLeadingCheckbox={isEditMode} style={{ maxHeight: allTopicsContainerMaxHeight }} />
                    </ZfAccordionItem>
                </ZfAccordion>
            </div>
        </div>
    );
};
